import * as React from "react";
import {
  ActivityFragment,
  UserMinimalFragment,
  CompanyMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { Link } from "../../wombat-ui";
import Avatar from "../../wombat-ui/Avatar";
import { Span } from "../../wombat-ui/components/Typography";
import ActivityPlate from "../ActivityPlate";

type UserCreatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: UserMinimalFragment;
};

export function isUserCreatedActivity(
  q: ActivityFragment
): q is UserCreatedActivity {
  return q.key === "user.created";
}

interface UserCreatedActivityProps {
  activity: UserCreatedActivity;
}

export const UserCreatedActivity: React.FC<UserCreatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();
  const { trackable, id } = activity;

  return (
    <ActivityPlate
      activity={activity}
      id="userCreatedActivity"
      visual={
        <Avatar
          src={trackable.avatar}
          alt={`${trackable.name} avatar`}
          type="user"
          size={10}
        />
      }
    >
      <Span className="text-sm">
        {t("activity.labels.talentCreated", {
          talent: (
            <Link to={`/users/${trackable.slug}`} key={id}>
              {trackable.name}
            </Link>
          ),
        })}
      </Span>
    </ActivityPlate>
  );
};
